import React from 'react';
import { withRouter } from 'react-router-dom';
import loadable from 'utils/loadable';
import LoadingIndicator from 'components/LoadingIndicator';

import { getLocalData } from 'utils/localDataStore';

// Pre-create the loadable components
const BlueshieldcaAssessment = loadable(
  () => import('./clients/BlueshieldcaAssessment'),
  {
    fallback: <LoadingIndicator />,
  },
);

const AssessmentContainerLoadable = loadable(
  () => import('./AssessmentContainer'),
  {
    fallback: <LoadingIndicator />,
  },
);

// Wrap AssessmentContainer with withRouter to ensure it receives routing props
const AssessmentContainer = withRouter(AssessmentContainerLoadable);

const LoadableAssessment = () => {
  const brand = getLocalData('brand')?.toLowerCase();

  switch (brand) {
    case 'bscsmartscreen':
    case 'bscsmartscreenuat':
      return <BlueshieldcaAssessment />;
    default:
      return <AssessmentContainer />;
  }
};

export default LoadableAssessment;
